import GenericModulePage from '../../components/generic/GenericModulePage';
import { initializeModule } from '../../utils/configInit';
import { manualConfig } from './manualConfig';
import { createManualValidationSchema } from './manualValidation';

const { config: initializedConfig } = initializeModule(
  manualConfig,
  createManualValidationSchema,
);

const ManualPage = () => <GenericModulePage config={initializedConfig} />;

ManualPage.displayName = 'ManualPage';

export default ManualPage;
